import * as React from 'react';
import { getHomepageUrl } from '../../../config/ConfigService';

const CookiePage = () => {
  React.useEffect(() => {
    document.cookie = 'auth0=;max-age=604800;domain=' + window.location.hostname;
    window.location.href = getHomepageUrl() + '/sign-up';
  }, []);

  return null;
};

export { CookiePage };
